import { Component, ElementRef, ViewChild } from '@angular/core';
import { navigationMenu } from '../../../content/navigation-menu';
import { NavigationMenuItem } from '../../../interfaces/navigation-menu.interface';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @ViewChild('navigationMenu') navigationMenu: ElementRef<HTMLElement>;
  @ViewChild('navigationButton') navigationButton: ElementRef<HTMLButtonElement>;
  public navigationMenuItems: NavigationMenuItem[];

  constructor() {
    this.navigationMenuItems = navigationMenu;
  }

  public toggleNavigationMenu(): void {
    this.navigationMenu.nativeElement.classList.toggle('hidden');
    this.navigationButton.nativeElement.classList.toggle('bg-gray-200');
  }

  public onHideNavigationMenu(): void {
    this.navigationMenu.nativeElement.classList.add('hidden');
    this.navigationButton.nativeElement.classList.remove('bg-gray-200');
  }
}
